/**
 * @file
 * TODO: Merge with address.ts
 */

// Exclusively matches with email addresses separated by commas & optional whitespace
export const EMAIL_REGEX =
  /^([\w-+.]+@([\w-]+\.)+[\w-]{1,63})(,\s*[\w-+.]+@([\w-]+\.)+[\w-]{1,63})*$/;

// Matches with email addresses from any string, doesn't specify comma or whitespace formatting
export const EMAIL_REGEX_GLOBAL =
  /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;

export class NoEmailToRecipientError extends Error {
  override name = "NoEmailToRecipientError";

  constructor() {
    super("At least one 'to' recipient is required to create a mailto link");
  }
}

export interface EmailHeader {
  readonly name?: string | null;
  readonly value?: string | null;
}

export function getEmailHeader(
  headers: readonly EmailHeader[] | undefined,
  names: string | readonly string[],
): string | undefined {
  const headerNames = typeof names === "string" ? [names] : names;
  return (
    headers?.find((header) =>
      headerNames.some(
        (name) => header.name?.toLowerCase() === name.toLowerCase(),
      ),
    )?.value ?? undefined
  );
}

export function normalizeContentId(
  contentId: string | null | undefined,
): string | null {
  const normalized = contentId?.replace(/[<>]/g, "").trim();
  return normalized ? normalized : null;
}

export function emailIsValid(email: string): boolean {
  return EMAIL_REGEX.test(email.toLowerCase());
}

export function extractEmail(string: string): string {
  const match: string[] | null = string.match(EMAIL_REGEX);
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  return match ? match[0] : "";
}

/**
 * Extracts email addresses from a string using regex
 * @param text - Text potentially containing email addresses
 * @returns Array of unique email addresses found
 */
export function extractMultipleEmailAddresses(text: string): string[] {
  if (!text) {
    return [];
  }

  // RFC 5322 compliant email regex (simplified for common cases)
  const emailRegex = EMAIL_REGEX_GLOBAL;

  const matches = text.match(emailRegex) || [];

  return [...new Set(matches)];
}
